<template>
  <div v-show="publicBAData.length + privateBAData.length + (disasterAlertData?.Forecasts?.length||0) > 0" id="BANotify" :class="{'collapse': collapse, 'have-l3': havePublicL3Alarm || havePrivateL3Alarm || haveDisasterAlert}">
    <button v-show="collapse" class="warning-icon-btn" @click="collapse = false">
      <div style="margin-top:5px">
        <i class="icon-warning"></i>
      </div>
      <div>{{ publicBAData.length + privateBAData.length + (disasterAlertData?.Forecasts?.length||0) > 99 ? '99+' : publicBAData.length + privateBAData.length + (disasterAlertData?.Forecasts.length||0) }}</div>
    </button>
    <div v-show="!collapse" class="alarm-area">
      <div class="alarm-header">
        <div class="alarm-header-context">
          告警管理
        </div>
        <button class="close-btn" @click="collapse = true">
          隱藏
        </button>
      </div>
      <template v-if="firstPublicBAData">
        <div class="alarm-title" :class="{ 'have-l3': havePublicL3Alarm }">
          <div class="alarm-title-context">
            公區告警
          </div>
          <div v-if="publicBAData.length > 1" class="to-more" @click="$openNewPageToPath({ name:'baEvent', query: { area: 'public' }})">
            查看其他 {{ publicBAData.length - 1 }} 則公區告警
            <i class="icon-m-next"></i>
          </div>
        </div>
        <div class="alarm-card" :class="{ 'have-l3': havePublicL3Alarm }">
          <div class="alarm-info">
            <div class="alarm-info-right">
              <div class="alarm-info-icon">
                <i class="icon-ba-public">
                  <i class="path1"></i>
                  <i class="path2"></i>
                  <i class="path3"></i>
                </i>
              </div>
              <div>
                <div class="alarm-info-level">
                  公區告警：{{ levelMap[firstPublicBAData.data.TagLevel] }}
                </div>
                <div class="alarm-info-content">
                  {{ firstPublicBAData.title }}
                </div>
                <div class="alarm-info-area">
                  位置：{{ firstPublicBAData.data.AssetPosition }}
                </div>
              </div>
            </div>
            <div class="alarm-info-time">
              {{ firstPublicBAData.data.timeSince }}
            </div>
          </div>
          <div class="alarm-btn-group">
            <button class="report-btn" @click="$openNewPageToPath({ name:'reportEventById', params: { id: firstPublicBAData.data.Id }})">
              回報
            </button>
            <button class="view-btn" @click="$openNewPageToPath({ name:'eventDetailById', params: { id: firstPublicBAData.data.Id }})">
              檢視
            </button>
          </div>
        </div>
      </template>
      <template v-if="firstPrivateBAData">
        <div class="alarm-title" :class="{ 'have-l3': havePrivateL3Alarm }">
          <div class="alarm-title-context">
            私區告警
          </div>
          <div v-if="privateBAData.length > 1" class="to-more" @click="$openNewPageToPath({ name:'baEvent', query: { area: 'private' }})">
            查看其他 {{ privateBAData.length - 1 }} 則私區告警
            <i class="icon-m-next"></i>
          </div>
        </div>
        <div class="alarm-card" :class="{ 'have-l3': havePrivateL3Alarm }">
          <div class="alarm-info">
            <div class="alarm-info-right">
              <div class="alarm-info-icon">
                <i class="icon-ba-private">
                  <i class="path1"></i>
                  <i class="path2"></i>
                  <i class="path3"></i>
                </i>
              </div>
              <div>
                <div class="alarm-info-level">
                  私區告警：{{ levelMap[firstPrivateBAData.data.TagLevel] }}
                </div>
                <div class="alarm-info-content">
                  {{ firstPrivateBAData.title }}
                </div>
                <div class="alarm-info-area">
                  位置：{{ firstPrivateBAData.data.AssetPosition }}
                </div>
              </div>
            </div>
            <div class="alarm-info-time">
              {{ firstPrivateBAData.data.timeSince }}
            </div>
          </div>
          <div class="alarm-btn-group">
            <button class="report-btn" @click="$openNewPageToPath({ name:'reportPrivateEventById', params: { id: firstPrivateBAData.data.Id }})">
              回報
            </button>
            <button class="view-btn" @click="$openNewPageToPath({ name:'privateEventDetailById', params: { id: firstPrivateBAData.data.Id }})">
              檢視
            </button>
          </div>
        </div>
      </template>
      <template v-if="disasterAlertData && disasterAlertData.Forecasts && disasterAlertData.Forecasts.length > 0">
        <div class="alarm-title">
          <div class="alarm-title-context">
            {{ $t('DisasterAlert.Title') }}
          </div>
        </div>
        <div v-for="v in disasterAlertData.Forecasts" :key="v.Type" class="alarm-card disaster">
          <div class="alarm-info">
            <div class="alarm-info-right">
              <div class="alarm-info-icon disaster">
                <img :src="v.Icon" alt="icon" />
              </div>
              <div>
                <div class="alarm-info-title">
                  {{ v.Title }}
                </div>
                <div class="alarm-info-area">
                  {{ v.Content }}
                </div>
                <div class="alarm-btn-group">
                  <div class="alarm-info-time">
                    {{ $t('DisasterAlert.ExpiredTime') }} {{ disasterAlertTime(disasterAlertData.ExpiredTime) }}
                  </div>
                  <button class="view-btn" @click="openDisasterDialog(v.Type)">
                    {{ $t('DisasterAlert.Show') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { apiDisasterForecasts } from '@/api/DisasterForecasts'
export default {
  data () {
    return {
      publicBAData: [], // 紀錄公區BA Level1、Level2 資料
      privateBAData: [], // 紀錄私區BA Level1、Level2 資料
      collapse: true, // 是否收合
      levelMap: {
        1: 'L1-低程度警報',
        2: 'L2-中程度警報',
        3: 'L3-高程度警報'
      },
      disasterAlertData: null
    }
  },
  computed: {
    firstPublicBAData () {
      if (this.publicBAData && this.publicBAData.length > 0) {
        return this.publicBAData.find((item) => item.data.TagLevel === 3) || this.publicBAData[0]
      }
      return null
    },
    firstPrivateBAData () {
      if (this.privateBAData && this.privateBAData.length > 0) {
        return this.privateBAData.find((item) => item.data.TagLevel === 3) || this.privateBAData[0]
      }
      return null
    },
    havePublicL3Alarm () {
      return this.publicBAData.some(item => item.data.TagLevel === 3)
    },
    havePrivateL3Alarm () {
      return this.privateBAData.some(item => item.data.TagLevel === 3)
    },
    haveDisasterAlert () {
      return this.disasterAlertData && this.disasterAlertData.Forecasts && this.disasterAlertData.Forecasts.length > 0
    }
  },
  mounted () {
    this.getAuth()
    window.addEventListener('storage', this.storageHandle)
    // 監聽 service worker 訊息
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', this.onServiceWorkerMessage)
    }
    this.checkDisasterAlertExpired()
  },
  destroyed () {
    // 取消監聽 service worker 訊息
    if (navigator.serviceWorker) {
      navigator.serviceWorker.removeEventListener('message', this.onServiceWorkerMessage)
    }
    window.removeEventListener('storage', this.storageHandle)
  },
  methods: {
    openDisasterDialog (type) {
      this.$emit('openDisasterDialog', type)
    },
    async fetchDisasterAlert () {
      try {
        // call api
        const res = await apiDisasterForecasts.getDisasterAlert()
        if (res.data.Data) {
          this.disasterAlertData = res.data.Data
          localStorage.setItem('disasterAlert', JSON.stringify(res.data.Data))
        } else {
          this.disasterAlertData = null
          localStorage.removeItem('disasterAlert')
        }
      } catch (e) {
        this.disasterAlertData = null
        localStorage.removeItem('disasterAlert')
      }
    },
    updateDisasterAlertFromServiceWorker (event) {
      if (event.data && event.data.FeatureName === 'disasterAlert') {
        const newAlert = event.data.Data
        localStorage.setItem('disasterAlert', newAlert)
        this.disasterAlertData = JSON.parse(newAlert)
      }
    },
    checkDisasterAlertExpired () {
      const alertStr = localStorage.getItem('disasterAlert')
      const communityId = localStorage.getItem('loginUserInfo')?.ComId
      if (alertStr) {
        const alertObj = JSON.parse(alertStr)
        if (alertObj.ExpiredTime && dayjs().isBefore(dayjs(alertObj.ExpiredTime)) && alertObj.CommunityId === communityId) {
          this.disasterAlertData = alertObj
          return
        } else {
          localStorage.removeItem('disasterAlert')
        }
      }
      this.fetchDisasterAlert()
    },
    disasterAlertTime (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm')
    },
    titleColorClass (level) {
      return 'notify-level' + level
    },
    // 判斷有無開啟BA功能
    async getAuth () {
      const auth = this.$isServiceEnabled(24) // 有無開啟BA功能
      if (auth) { // 有開
        this.displayState()
      } else {
        this.recordState()
      }
    },
    // 取得或記憶目前顯示狀態
    displayState () {
      if (sessionStorage.getItem('BA-alert-displayState') !== null) {
        const state = JSON.parse(sessionStorage.getItem('BA-alert-displayState'))
        this.collapse = state.collapse
        if (localStorage.getItem('BA-alert'))
        { this.publicBAData = JSON.parse(localStorage.getItem('BA-alert')).other }
        if (localStorage.getItem('BA-private-alert'))
        { this.privateBAData = JSON.parse(localStorage.getItem('BA-private-alert')).other }
      } else {
        this.recordState()
      }
    },
    // 記錄目前顯示狀態，並存入sessionStorage
    recordState () {
      let stateObj = {
        collapse: this.collapse
      }
      if (sessionStorage.getItem('BA-alert-displayState') !== null) { stateObj = JSON.parse(sessionStorage.getItem('BA-alert-displayState')) }
      sessionStorage.setItem('BA-alert-displayState', JSON.stringify(stateObj))
    },
    storageHandle (event) {
      const key = event.key
      if (key !== 'BA-private-alert' && key !== 'BA-alert') return
      if (JSON.parse(localStorage.getItem(key))?.other) {
        const newOtherEvent = JSON.parse(localStorage.getItem(key)).other
        const nowEventIds = key.includes('private') ? this.privateBAData.map((item) => item.data.Id) : this.publicBAData.map((item) => item.data.Id)
        const newEventIds = newOtherEvent.map((item) => item.data.Id)
        const haveNewEvent = newEventIds.some((item) => !nowEventIds.includes(item))
        if (haveNewEvent) {
          this.collapse = false
          this.recordState()
        }
        if (key.includes('private')) this.privateBAData = newOtherEvent
        else this.publicBAData = newOtherEvent
      }
    },
    onServiceWorkerMessage (event) {
      if (event.data && event.data.FeatureName === 'BA-alert' && parseInt(event.data.TagLevel) === 3) {
        this.collapse = false
        this.recordState()
      }
      if (event.data && event.data.FeatureName === 'disasterAlert') {
        this.collapse = false
        this.updateDisasterAlertFromServiceWorker(event)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#BANotify
  padding: 0 7px 7px
  transition: all 0.5s
  transform: translateX(0px)
  &.have-l3
    .warning-icon-btn
      background-color: $systemBAOrange !important
      color: $white !important
    .close-btn
      border-color: $systemBAOrange !important
      color: $systemBAOrange !important

  .warning-icon-btn
    cursor: pointer
    font-size: 20px
    font-weight: bold
    width: 80px
    height: 80px
    text-align: center
    border-radius: 100%
    border: unset
    outline: unset
    background-color: $white
    color: $systemBAOrange
    .icon-warning
      font-size: 40px
    .alarm-info-level
      color: $white
  .alarm-area
    width: 440px
    background-color: $white
    border-radius: 12px
    padding: 16px
    box-shadow: -4px 0 8px 0 rgba(0, 0, 0, 0.12), 0 4px 8px 0 rgba(0, 0, 0, 0.12)
    .alarm-header
      display: flex
      justify-content: space-between
      align-items: center
      .alarm-header-context
        font-size: 20px
        font-weight: bold
        color: $mainFontColor
      .close-btn
        cursor: pointer
        background-color: transparent
        border-radius: 100px
        padding: 6px 16px
        border: 1px solid $mainColor
        color: $mainColor
    .alarm-title
      display: flex
      justify-content: space-between
      align-items: center
      margin-top: 28px
      &.have-l3
        .to-more
          color: $systemBAOrange !important
      .alarm-title-context
        font-size: 18px
        font-weight: bold
        color: $mainFontColor
      .to-more
        cursor: pointer
        display: flex
        align-items: center
        color: $mainColor
        font-size: 18px
        font-weight: bold
    .alarm-card
      padding: 12px
      margin-top: 16px
      background-color: transparent
      border: 1px solid $borderDark1
      border-radius: 12px
      &.have-l3
        background-color: $systemBAOrange !important
        border-color: $systemBAOrange !important
        .alarm-info-level
          color: $white !important
        .alarm-info-icon
          background-color: $white !important
        .alarm-info-content
          color: $white !important
        .alarm-info-area
          color: $white !important
        .report-btn
          color: $white !important
        .view-btn
          background-color: $white !important
          color: $systemBAOrange !important
        .alarm-info-time
          color: $white !important
      .alarm-info
        display: flex
        justify-content: space-between
        .alarm-info-right
          display: flex
          .alarm-info-icon
            padding: 8px
            width: 48px
            height: 48px
            border-radius: 100%
            background-color: $borderDark3
            margin-right: 10px
            .icon-ba-public,
            .icon-ba-private
              font-size: 48px
              .path3::before
                color: $systemBAOrange !important
          .alarm-info-level
            color: $subFontColor
            font-size: 18px
          .alarm-info-content
            margin-top: 16px
            color: $systemBAOrange
            font-size: 20px
            font-weight: bold
          .alarm-info-area
            margin-top: 16px
            color: $mainFontColor
            font-size: 18px
        .alarm-info-time
          font-size: 14px
          color: $subFontColor
      .alarm-btn-group
        margin-top: 8px
        text-align: right
        .report-btn
          cursor: pointer
          font-size: 14px
          color: $mainColor
          text-decoration: underline
          text-underline-offset: 3px
          background-color: transparent
          border: unset
          outline: unset
          margin-right: 16px
        .view-btn
          cursor: pointer
          padding: 8px 26px
          background-color: $mainColor
          color: $white
          font-size: 14px
          border-radius: 4px
          border: unset
          outline: unset
      &.disaster
        .alarm-btn-group
          display: flex
          justify-content: space-between
          align-items: top
          margin-top: 10px
        .alarm-info-time
          color: $lightFontColor
        .alarm-info-area
          font-size: 16px !important
          line-height: 1.4 !important
        .alarm-info-title
          font-size: 20px
          font-weight: bold
        .alarm-info-icon
          background-color: #2C4F64 !important

  .buttonGroup
    height: 32px
    display: flex
    justify-content: flex-end
    margin-top: 8px
    transition: all 0.5s
    .btn
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16)
      padding: 0px 16px
      cursor: pointer
      background-color: $white
      border-radius: 100px
      .buttonContent
        color: $mainColor
        font-weight: 600
        font-size: 15px
        line-height: 32px
      &.controlButton // 收合或展開button
        margin-left: 12px
        i
          margin-left: 4px
  .notifyGroup
    height: calc( 100% - 32px )
    display: flex
    flex-direction: column
    .notify
      width: 408px
      max-width: 408px
      border-radius: 12px
      box-shadow: 0 0 8px 0 #0003
      padding: 12px 12px 20px 16px
      position: relative
      margin-top: 8px
      transition: all 0.5s
      &:nth-child(1)
        z-index: 1
      &:nth-child(n+2)
        z-index: 0
      &:last-child
        margin-bottom: 20px
      .sign
        line-height: 24px
        display: flex
        margin-bottom: 8px
        color: $subFontColor
        i
          font-size: 24px
          margin-right: 8px
        .text
          color: $subFontColor
        .tagLevel
          font-weight: 600
      .title
        font-size: 21px
        font-weight: 600
        line-height: 29px
        margin-bottom: 4px
        +word-break-line(1)
      .subTitle
        display: flex
        font-size: 19px
        line-height: 27px
        .position
          min-width: 57px
        .assetPosition
          font-weight: 600
          width: calc( 100% - 180px )
          +word-break-line(1)
      .button
        position: absolute
        right: 12px
        bottom: 8px
        a:nth-child(2)
          margin-left: 16px
    .notify-level1, .notify-level2
      background-color: $white
      .sign
        color: $hintColor
        .text
          color: $hintColor
      .title
        color: $infoColor
      .subTitle
        color: $hintColor

    .notify-level3
      background-color: rgba($warnGrayColor, 0.9)
      backdrop-filter: blur(12px)
      .sign
        color: $white
        .text
          color: $white
      .title
        color: $white
      .subTitle
        color: $white
      .el-button
        color: $white
      .el-button--primary
        border-color: $white
        color: $warnGrayColor
        background-color: $white

  &.collapse
    overflow: hidden
    .notifyGroup
      position: relative
      height: 140px
      .notify
        &:nth-child(n+2)
          position: absolute
          top: 16px
          width: 90%
          margin: 0 2%
        &:nth-child(n+3)
          box-shadow: none
</style>
